module.exports = __webpack_public_path__ + "static/media/vehicle2.2edc4f48.svg";